import UserProfileWidget from "./userProfileWidget";

export default UserProfileWidget;
